import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilService } from '@app/service/util.service';
import { BoardService } from '@app/home/service/board.service';

import { CommonService } from '@app/service/common.service';
import { Globals } from '@app/service/globals.service';
import { config } from '@app/service/config.service';

import { ToastrService } from 'ngx-toastr';

import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

@Component({
  selector: 'app-board-view',
  templateUrl: './board-view.component.html',
  styleUrls: ['./board-view.component.scss']
})
export class BoardViewComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public baseURL = config.baseUrl;

  public data: any = {
    detail: {contents: '', subject: ''},
    upload: []
  };

  public params: any = {
    type: 'view',
    board_id: 'notice',
    group_id: '',
    row: 15,
    no: 1,
    group: 'subject',
    text: '',
    board_seq: ''
  };

  public boardInfo: any = {};
  public memberInfo: any = {};

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    public utilService: UtilService,
    private boardService: BoardService,
    public globals: Globals
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);
  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.params.board_id = ( typeof params.board_id == 'undefined' || params.board_id == '' ) ? 'notice' : params.board_id;
      this.params.board_seq = ( typeof params.board_seq == 'undefined' || params.board_seq == '' ) ? '0' : params.board_seq;
      this.params.type = ( typeof params.type == 'undefined' || params.type == '' ) ? 'view' : params.type;
      this.params.group_id = ( typeof params.group_id == 'undefined' || params.group_id == '' ) ? '' : params.group_id;
      this.params.row = ( typeof params.row == 'undefined' || params.row == '' ) ? '15' : params.row;
      this.params.no = ( typeof params.no == 'undefined' || params.no == '' ) ? '1' : params.no;
      this.params.group = ( typeof params.group == 'undefined' || params.group == '' ) ? 'subject' : params.group;
      this.params.text = ( typeof params.text == 'undefined' || params.text == '' ) ? '' : params.text;
      this.getBoardInfo( this.params.board_id );
    });
  }

  /*******************************************************************************
    설  명 : 목록으로
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  list() {
    this.params.board_seq = '';
    this.params.type = 'list';

    this.router.navigate(
    ['/en/board/list'],
    {
      relativeTo: this.activatedRoute,
      queryParams: this.params,
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 게시판 정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBoardInfo( board_id: any ) {
    this.boardService.getBoardInfoId( this.params.board_id ).then( response => {
      if( response.ResultCode ) {
        this.boardInfo = response.data;

        // 게시글 정보 가져오기
        this.getBoardView( this.params );

      } else {
        // indicator 표시 숨김
        this.globals.indicator.next(false);

        this.toastrService.error( response.ResultMessage, "게시판 에러" );

        this.router.navigate( ['/main'] );
        return false;
      }
    }, error => {
      this.globals.indicator.next(false);
      console.log( error );

      this.toastrService.error( "존재하지 않는 게시판입니다.", "게시판 에러" );
    });
  }

  /*******************************************************************************
    설  명 : 게시글 내용 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBoardView( params ) {
    this.boardService.getBoardView( params.board_id, params.board_seq, true ).then( response => {
      if( response.ResultCode ) {
        let tmp = {
          detail: response.data,
          upload: response.upload
        };

        this.data = tmp;
        this.globals.indicator.next(false);
      } else {
        console.log( response );
        this.globals.indicator.next(false);
        this.toastrService.error( response.ResultMessage, "게시글 에러" );

        this.router.navigate( ['/main'] );
        return false;
      }
    }, error => {
      this.globals.indicator.next(false);
      console.log( error );

      this.toastrService.error( "존재하지 않는 게시글입니다.", "게시글 에러" );
    });
  }

  /*******************************************************************************
    설  명 : 서브메뉴 링크
    입력값 : item = 메뉴 array
    리턴값 : 없음
  *******************************************************************************/
  goLink( menu ) {
    let href = menu.link_url;
    let boardId = menu.board_id;
    let menuIndex = menu.seq;

    if (href === '') {
      let result = false;
      const link = function getURL(item) {
        if (item.link_url === '' && item.board_id === '') {
          for (const element of item.children) {
            getURL(element);
            if (result) {
              return false;
            }
          }
        } else {
          href = item.link_url;
          boardId = item.board_id;
          menuIndex = item.seq;
          result = true;
        }
      };
      link(menu);
    }

    if ( boardId === '' ) {
      this.router.navigate([ href ], { queryParams: { menu_seq: menuIndex }});
    } else {
      this.router.navigate([ (href !== '' ? href : '/board/list') ], { queryParams: { board_id: boardId } });
    }
  }
}
